import { formatActivityNoteDobLines } from "./dob-display.util";

/**
 * Escape plain text for safe insertion into HTML (e.g. innerHTML with bypass).
 */
export function escapeHtmlForInnerText(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Wraps `#tag`-style tokens in a span for yellow highlight in activity UIs.
 * Matches the same pattern as the add-note composer (`#[^\s#]+`).
 */
export function buildActivityNoteTagHighlightHtml(text: string | null | undefined): string {
  const raw = formatActivityNoteDobLines(text ?? '');
  if (!raw) {
    return '';
  }
  const parts = raw.split(/(#[^\s#]+)/g);
  return parts
    .map((part) => {
      if (part.startsWith('#') && part.length > 1) {
        return `<span class="activity-note-tag-token">${escapeHtmlForInnerText(part)}</span>`;
      }
      return escapeHtmlForInnerText(part);
    })
    .join('');
}
